// ============== CART JS ===============
var $submitBtn = $('button.btn-submit'),
    $ajaxSubmit = $('#AjaxSubmitBtn')
    noteArray = [];


$("body").on("click", "button.btn-submit", function(evt){
  console.log('do an alert so it doesnt redirect you');

  var date = new Date($('#deliveryDatePicker input[name="zpDate"]').val()),
      time = $('#deliveryDatePicker input[name="zpTime"]').val(),
      pickupDate = new Date($('#pickupDatePicker input[name="zpDate"]').val()),
      pickupTime = $('#pickupDatePicker input[name="zpTime"]').val(),
      deliveryOption = $('.checkoutMethodContainer.delivery').length,
      pickupOption= $('.checkoutMethodContainer.pickup').length,
      dayArray = new Array(7);
      
      dayArray[0] = "Sunday";
      dayArray[1] = "Monday";
      dayArray[2] = "Tuesday";
      dayArray[3] = "Wednesday";
      dayArray[4] = "Thursday";
      dayArray[5] = "Friday";
      dayArray[6] = "Saturday";


      if ($('#agree').is(':checked')) {

        if ((pickupOption == 1 && pickupDate == "Invalid Date") || (pickupOption == 1 && !pickupTime)) {
          console.log(pickupDate);
          alert("Please enter a valid pickup date");
          return false;
        }

        if ((deliveryOption == 1 && date == "Invalid Date") || (deliveryOption == 1 && !time) ) {
          alert("Please enter a valid delivery date");
          return false;
        }

        if (pickupOption == 1) {
          var newPickupDate = (dayArray[pickupDate.getDay()] + ' ' + (pickupDate.getMonth() + 1) + '/' + pickupDate.getDate() + '/' + pickupDate.getFullYear());

          noteArray.push('Delivery Date:' + newPickupDate);
          noteArray.push('|Delivery Time:' + pickupTime);
        }
        if (deliveryOption == 1) {
          newDeliveryDate = (dayArray[date.getDay()] + ' ' + (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
          noteArray.push('Delivery Date:' + newDeliveryDate);
          noteArray.push('|Delivery Time:' + time);
        }

        noteArray.push('|Building Type: ' + $('#BuildingType').val());
        noteArray.push('|Card Message:' + $('#GiftInstructions').val());
        noteArray.push('|Instructions: ' + $('#CartSpecialInstructions').val());
        $('#CartSpecialInstructions').val(noteArray);
      
        $('.cart').submit();


      }
      else {
        evt.preventDefault();
        alert("You must agree with the terms and conditions of sales to check out.");
        console.log(noteArray);
        return false;
      }
})  



$(document).on('ready', function(){
  if($('body').is('#your-shopping-cart')) {
    $('#CartSpecialInstructions').val('');
    noteArray = [''];
  }
})



// ============ AJAX CART JS =============
$(document).on('click', "#AjaxSubmitBtn", function(evt) {
  evt.preventDefault();
  console.log(evt)
  window.location = '/cart';
})

// =============== PDP JS ================
$("#pickup").change(function() {
    if(this.checked) {
      $('.submit-btn-container-pickup').addClass('active');
      $('.submit-btn-container').addClass('hide');
    $('.fa-remove').trigger('click');
      $('.select-row.delivery-select').addClass('hide');
      $('.select-row.zip-code-select').addClass('hide');
    }
    else {
      $('.submit-btn-container-pickup').removeClass('active');
      $('.submit-btn-container').removeClass('hide');
      $('.select-row.delivery-select').removeClass('hide');
      $('.select-row.zip-code-select').removeClass('hide');
    }
});
$(document).ready(function(){
  $('#pickup').removeAttr('checked');
})
